/*--------------------------------------
	불러톡 — Socket.io 연결/수신/송신 (ChatSocket)

	소켓 연결과 수신 핸들러, 송신(emit) 래퍼를 담당한다.
	상태는 메인 Chat(this.chat)이 보유하며, 그리기는 chat.draw, HTTP 는 chat.ajax 에 위임.
	socket.io 연결 자체는 this.io 에 보관한다.
--------------------------------------*/
import { htmlspecialchars } from './Draw';

export default class ChatSocket {
	/**
	 * @param chat 메인 Chat 인스턴스(상태 공유)
	 */
	constructor(chat){
		this.chat = chat;
		this.io = null; // socket.io 연결
	}

	/**
	 * 연결 + 수신 핸들러 등록.
	 * transports: ['websocket'] — 폴링 핸드셰이크 생략, LB sticky 없이 3노드 분산해도 한 노드에 고정.
	 * (노드 간 메시지는 Redis adapter 가 공유)
	 */
	connect(){
		const self = this;
		const chat = this.chat;
		this.io = io(chat.chatHost, { path: '/talk', transports: ['websocket'] });
		const socket = this.io;

		socket.on('connect', function(){
			chat.isMobile = window.App ? 'mobile' : 'PC';
			socket.emit('adduser', [chat.userName, chat.roomName, chat.isMobile, chat.myIP]);
		});

		socket.on('reload_notread_cnt', function(data){
			const [roomNo] = data;
			self.notReadLiveCheck(roomNo);
		});

		socket.on('pushNoticeGo', function(data){ self.onPushNotice(data); });

		// 채팅메세지 수신 — body(6번째)는 구조화 JSON. 구버전 서버/클라는 없을 수 있어(undefined) talkBox 가 msg 로 폴백.
		socket.on('chat message', function(data){
			const [msg, writerNo, saveno, memberName, isAdmin, body] = data;
			chat.draw.onRecvMsg({
				isTalkManager: isAdmin,
				sent_date: dayjs().format('YYYY-MM-DD HH:mm:ss'),
				sender_num: writerNo,
				sender_name: memberName,
				num: saveno,
				msg,
				body: body || null,
			});
		});

		// 입력중 표시 — 관리자끼리만(회원 화면은 무시). [name, isTalkAdmin, profileImg]
		socket.on('typing', function(data){
			const [name, , profileImg] = data;
			if( !chat.isAdminPage ) return; // 회원 화면 제외
			chat.draw.showTyping(name, profileImg);
		});

		socket.on('updaterooms', function(data){
			const [roomMemberCnt] = data;
			chat.currentMember = roomMemberCnt;
			if( $('#orderin1').length && $('#send_callbtn').length ){
				$('#send_callbtn').css('display', 'block');
				clear_noticeClear();
			}
		});

		socket.on('checkUsers_In_RoomResult', function(data){
			const [roomMemberCnt, membersList] = data;
			chat.currentMember = roomMemberCnt;
			chat.currentMembersList = membersList;
			if( chat.uploadMode == 1 ) chat.ajax.sendMessageToGo();
			else                       chat.ajax.startUpload();
		});
	}

	/**
	 * 연결 종료. (Chat.destroy 에서 호출)
	 */
	disconnect(){
		if( this.io ){ this.io.disconnect(); this.io = null; }
	}

	/**
	 * DB 저장이 끝난 메세지를 소켓서버로 emit (화면에만 그리기).
	 * @param data {msg, id, file_id}
	 */
	sendToNode(data){
		const chat = this.chat;
		let id = parseInt(data.id);
		if( isNaN(id) ) id = 0;

		const body = data.body || null;                                // 구조화 JSON 본문(배열 꼬리에 동봉)
		const msgg = htmlspecialchars(String(data.msg == null ? '' : data.msg)); // 구버전 클라/푸시 미리보기용 평문 fallback

		// 끝에 body 추가 — 구버전 수신측은 무시(무impact), 신버전은 body 우선 렌더
		this.io.emit('chat message', [msgg, chat.myMbno, chat.roomMembers, chat.roomName, id, chat.talkName, chat.isTalkAdmin, body]);
		chat.draw.showAbsentReply(id); // 부재중(에티켓 시간) 자동답변 — 소켓 없이 내 화면에만(ChatDraw)
		chat.draw.showSendBtn();
		$('#sendmessagcont').focus();

		if( $('#apporderBtn').length ){
			$('#sendmessagcont').css('height', '20px');
			$('#addChatMoreBtn').css('top', '0px');
			$('#send_callbtn').css('top', '0px');
		}
	}

	/**
	 * 전송 — 방 접속자 확인 후 checkUsers_In_RoomResult 에서 실제 전송.
	 */
	sendMessage(){
		this.chat.uploadMode = 1;
		this.io.emit('checkUsers_In_Room');
	}

	/**
	 * 입력중(typing) 발신 — 같은 방 다른 관리자에게 전달. (호출측에서 throttle)
	 */
	emitTyping(){
		if( !this.io ) return;
		const chat = this.chat;
		const img = chat.avatarMap[chat.myMbno] || ''; // 내 프사(썸네일) — initData 에서 시드됨
		this.io.emit('typing', [chat.talkName, chat.isTalkAdmin, img]);
	}

	/**
	 * 폼 파일을 서버로 전송(업로드 모드).
	 * @param formData
	 */
	sendFileToDb(formData){
		this.chat.uploadMode = 2;
		this.chat.uploadFormData = formData;
		this.io.emit('checkUsers_In_Room');
	}

	/**
	 * 푸시 알림 발송(소켓 pushNoticeGo) — 토큰 수집 후 save_dbFirst.php 호출.
	 * @param data [notiTogoList, msg]
	 */
	onPushNotice(data){
		const [notiTogoList, msg] = data;

		const pInfos = {};
		pInfos.ImageLinkUrl = '';
		pInfos.message = msg.substr(0, 30);

		if( msg.indexOf('img src=/') > 0 && msg.indexOf('id=chatImage') > 1 ){
			const ts = msg.split(' ');
			let tm = ts[1].replace('src=/', 'http://miz6n4.com/');
			if( tm.indexOf('_thumb.') ) pInfos.ImageLinkUrl = tm;
			tm = msg.split('>');
			const tt = tm[tm.length - 2];
			const mgnew = tt.split('<')[0];
			if( mgnew.length > 0 ) pInfos.message = mgnew.substr(0, 30);
		} else if( msg.indexOf('img src=/') > 0 && msg.indexOf('id=chatUpload_linkFile') > 1 ){
			pInfos.ImageLinkUrl = '';
			const tt = msg.split('>')[2];
			const mgnew = tt.split('<')[0];
			if( mgnew.length > 0 ) pInfos.message = '파일첨부 :' + mgnew.substr(0, 30);
		}

		pInfos.title = this.chat.talkName;
		pInfos.notyTypen = 1;
		pInfos.linkurl = '/mobile/alert.php';

		const tokenAndroid = [];
		const tokenIos = [];
		const eaMemlist = [];
		for( const key in notiTogoList ){
			const eaData = notiTogoList[key];
			eaMemlist.push(eaData[2].replace('U_', ''));
			if( eaData[0] == 'android' ) tokenAndroid.push(eaData[1]);
			if( eaData[0] == 'IOS' ) tokenIos.push(eaData[1]);
		}
		pInfos.roomno = this.chat.roomName;
		pInfos.members = eaMemlist;
		pInfos.tokens_IOS = tokenIos;
		pInfos.tokens_android = tokenAndroid;

		$.post('/save_dbFirst.php', { jobAct: 'mizSayTalkNoticeDo', pInfos: pInfos });
	}

	/**
	 * 안읽음 뱃지 라이브 갱신(소켓 reload_notread_cnt).
	 * 읽음처리 자체는 서버 send()/messages() 에서 끝났고, 여기선 헤더 뱃지를 서버 최신값으로 재조회.
	 * @param roomNo 변동이 생긴 방번호
	 */
	notReadLiveCheck(roomNo){
		const chat = this.chat;
		// 관리자 불러톡은 단일 대화 팝업이라 헤더 뱃지 자체가 없다.
		if( chat.isTalkAdmin == 1 ) return;

		$.post('/m/ajax/chat/new', {}, function(res){
			const cnt = (res && res.cnt) ? parseInt(res.cnt, 10) : 0;
			const $top = $('#notyRoomTop');
			if( cnt > 0 ) $top.html(cnt).show();
			else          $top.empty().hide();
			// 다른 페이지 이동 시 서버 재렌더용 클라이언트 캐시값도 맞춰둔다.
			if( !chat.isAdminPage ) MEMBER['talk_cnt'] = cnt > 0 ? cnt : null;
		}, 'json');
	}
}